module.exports = __webpack_public_path__ + "img/tarj2-2.1f8b0ce1.svg";